/**
 * SortDown Icon Component
 * 
 * SVG icon for descending sort indicator
 */

import React from 'react';

const SortDownIcon = ({ size = 12, color = 'currentColor', className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`sort-down-icon ${className}`}
      aria-hidden="true"
      {...props}
    >
      <polyline points="7 13 12 18 17 13"></polyline>
      <polyline points="7 6 12 11 17 6"></polyline>
    </svg>
  );
};

export default SortDownIcon;
